// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"5172ef88","977":"580504a8"}[chunkId] + ".chunk.js";
};